// extracted by mini-css-extract-plugin
export var alignLeft = "x_rd d_fp d_bG d_dv";
export var alignCenter = "x_bP d_fq d_bD d_dw";
export var alignRight = "x_rf d_fr d_bH d_dx";
export var alignColumnLeft = "x_sP d_fs d_bN d_dv";
export var alignColumnCenter = "x_sQ d_ft d_bP d_dw";
export var alignColumnRight = "x_sR d_fv d_bQ d_dx";
export var milestonesContainer = "x_sS d_dW";
export var milestonesContainerFull = "x_sT d_dT";
export var milestonesSubtitle = "x_mf d_mf d_cs";
export var milestonesComponentWrapper = "x_mb d_mb d_cv";
export var compContentWrapper = "x_sV d_mc d_bz d_bJ d_bM d_bF d_c7 d_H";
export var milestonesMainHeader = "x_l8 d_l8 d_w d_cr";
export var milestonesSubHeader = "x_l9 d_l9 d_w";
export var milestonesComponentWrapperRow = "x_sW d_H";
export var milestonesBlockWrapper = "x_sX";
export var milestonesTextBlockWrapper = "x_sY";
export var milestonesComponentHeader = "x_md d_md d_w d_cr";
export var milestonesComponentParagraph = "x_mj d_mj d_w";
export var btnWrapper = "x_d2 d_bz d_ck";
export var btnWrapperCards = "x_sZ d_bz d_cd";
export var imageWrapper = "x_rj d_cs d_bz";
export var Title1Small = "x_s0 G_s0 G_tV G_tW";
export var Title1Normal = "x_s1 G_s1 G_tV G_tX";
export var Title1Large = "x_s2 G_s2 G_tV G_tY";
export var Title2Small = "x_s3 G_s3 G_tV G_tZ";
export var Title2Normal = "x_s4 G_s4 G_tV G_t0";
export var Title2Large = "x_s5 G_s5 G_tV G_t1";
export var SubtitleSmall = "x_pd G_pd G_tV G_t5";
export var SubtitleNormal = "x_pf G_pf G_tV G_t6";
export var SubtitleLarge = "x_pg G_pg G_tV G_t7";
export var Subtitle2Small = "x_s6 G_s6 G_tV G_t8";
export var Subtitle2Normal = "x_s7 G_s7 G_tV G_t9";
export var Subtitle2Large = "x_s8 G_s8 G_tV G_vb";
export var BodySmall = "x_s9 G_s9 G_tV G_vc";
export var BodyNormal = "x_tb G_tb G_tV G_vd";
export var BodyLarge = "x_tc G_tc G_tV G_vf";
export var exceptionLineHeight = "x_td G_vm";